(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  // ============================================================
  // Reveal on scroll
  // ============================================================
  const reveals = document.querySelectorAll('.v2-reveal');
  if (reveals.length) {
    const io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );
    reveals.forEach(function (el) { io.observe(el); });
  }

  // ============================================================
  // Image zoom-out on scroll
  // Wraps editorial images in a zoom container that scales from
  // 1.15 to 1.0 as the image scrolls into the viewport.
  // ============================================================
  function setupZoomIn() {
    const zoomSelectors = [
      '.v2-hero__image',
      '.v2-signature__img',
      '.v2-story__image',
      '.v2-occasions__img',
      '.v2-favorites__img',
      '.v2-collection__hero-img',
      '.v2-product__main-img',
      '.v2-signature__media img',
    ];

    const images = document.querySelectorAll(zoomSelectors.join(','));

    images.forEach(function (img) {
      // Skip if already wrapped or in a slider (slider has own animation)
      if (img.closest('.v2-zoom-in')) return;
      if (img.closest('.v2-hero__media--slider')) return;

      // Wrap the image visually by using its existing parent if it has overflow:hidden
      // Otherwise add the class to the image's container
      let target = img.parentElement;
      const parentStyles = window.getComputedStyle(target);
      if (parentStyles.overflow !== 'hidden' && parentStyles.overflowX !== 'hidden') {
        // Create a wrapper for the image
        const wrapper = document.createElement('span');
        wrapper.className = 'v2-zoom-in';
        wrapper.style.display = 'block';
        wrapper.style.width = '100%';
        wrapper.style.height = '100%';
        img.parentNode.insertBefore(wrapper, img);
        wrapper.appendChild(img);
        target = wrapper;
      } else {
        target.classList.add('v2-zoom-in');
      }
    });

    const zoomTargets = document.querySelectorAll('.v2-zoom-in');
    if (!zoomTargets.length) return;

    const zoomIO = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            zoomIO.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px -10% 0px' }
    );
    zoomTargets.forEach(function (el) { zoomIO.observe(el); });
  }

  setupZoomIn();

  // ============================================================
  // Re-observe new reveals added dynamically (Shopify customizer)
  // ============================================================
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.v2-reveal:not(.is-visible)').forEach(function (el) {
      el.classList.add('is-visible');
    });
    setupZoomIn();
  });
})();
